<template>
  <div
    class="tab__wrap"
    role="tablist"
    aria-label="콘텐츠 탭"
    :class="tabWrapClass"
  >
    <button
      v-for="(tab, index) in tabs"
      :key="index"
      type="button"
      role="tab"
      :id="`tab-${index}`"
      :aria-selected="selectedIndex === index ? 'true' : 'false'"
      :aria-controls="`tabpanel-${index}`"
      :tabindex="selectedIndex === index ? -1 : 0"
      @click="selectTab(index)"
      @keydown="onKeydown($event, index)"
      class="tab"
      :class="{ 'is-active': selectedIndex === index }"
      :title="typeof tab === 'string' ? tab : tab.tooltip || tab.label"
    >
      {{ typeof tab === "string" ? tab : tab.label }}
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  tabs: { type: Array, required: true },
  modelValue: { type: Number, default: 0 },
  tabWrapClass: { type: [String, Array, Object], default: "" },
});

const emit = defineEmits(["update:modelValue"]);
const selectedIndex = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    selectedIndex.value = val;
  }
);

function selectTab(index) {
  selectedIndex.value = index;
  emit("update:modelValue", index);
}

// 키보드 좌/우 화살표 이동
function onKeydown(event, index) {
  const lastIndex = props.tabs.length - 1;
  if (event.key === "ArrowRight") {
    const next = index === lastIndex ? 0 : index + 1;
    selectTab(next);
    focusTab(next);
  } else if (event.key === "ArrowLeft") {
    const prev = index === 0 ? lastIndex : index - 1;
    selectTab(prev);
    focusTab(prev);
  }
}

function focusTab(index) {
  const tabEl = document.getElementById(`tab-${index}`);
  tabEl?.focus();
}
</script>
